export type ResultMotionKind = "filter" | "search" | "tag";

export interface ResultCardBounds {
  left: number;
  top: number;
}

export interface ResultMotionSnapshot {
  cards: Map<string, ResultCardBounds>;
  id: number;
  kind: ResultMotionKind;
  originModelId?: string;
}

export interface ResultCardMove {
  id: string;
  x: number;
  y: number;
}

export interface ResultCardMotionPlan {
  entering: string[];
  leaving: string[];
  moves: ResultCardMove[];
}

export function captureResultCardBounds(
  root: ParentNode | null
): Map<string, ResultCardBounds> {
  const bounds = new Map<string, ResultCardBounds>();
  if (!root) return bounds;

  for (const card of root.querySelectorAll<HTMLElement>(
    ".release-list--virtual .model-card-shell[data-model-id]"
  )) {
    const id = card.dataset.modelId;
    if (!id) continue;
    const rect = card.getBoundingClientRect();
    bounds.set(id, { left: rect.left, top: rect.top });
  }

  return bounds;
}

export function buildResultCardMotionPlan(
  before: ReadonlyMap<string, ResultCardBounds>,
  after: ReadonlyMap<string, ResultCardBounds>
): ResultCardMotionPlan {
  const entering: string[] = [];
  const leaving: string[] = [];
  const moves: ResultCardMove[] = [];

  for (const [id, next] of after) {
    const previous = before.get(id);
    if (!previous) {
      entering.push(id);
      continue;
    }

    moves.push({
      id,
      x: previous.left - next.left,
      y: previous.top - next.top
    });
  }

  for (const id of before.keys()) {
    if (!after.has(id)) leaving.push(id);
  }

  return { entering, leaving, moves };
}
